'use strict';

import { CoreRepository } from '../CoreRepository';
import { GlobSunfireOrg } from '../../Entities/Glob/GlobSunfireOrg';
import { GlobSunfireOrgCollection } from '../../Collections/Glob/GlobSunfireOrgCollection';

export class GlobSunfireOrgRepository extends CoreRepository {
  public getGlobSunfireOrgs() {
    return this.webAPI.getGlobSunfireOrgs().then((response) => {
      const collection = new GlobSunfireOrgCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new GlobSunfireOrg();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }
}
